import { render, staticRenderFns } from "./Proj.vue?vue&type=template&id=7589a352&scoped=true"
import script from "./Proj.vue?vue&type=script&lang=js"
export * from "./Proj.vue?vue&type=script&lang=js"
import style0 from "./Proj.vue?vue&type=style&index=0&id=7589a352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589a352",
  null
  
)

export default component.exports